const firebaseConfig = {
  apiKey: "AIzaSyADxMql0nfog-F8wp4KVPtaA9l_i3wN4I4",
  authDomain: "appartment-hunt-8fa1e.firebaseapp.com",
  projectId: "appartment-hunt-8fa1e",
  storageBucket: "appartment-hunt-8fa1e.appspot.com",
  messagingSenderId: "910384130349",
  appId: "1:910384130349:web:261b9dc47a064830bbcba4"
  };
  export default firebaseConfig;